import { currentRegionFromMetaTag } from "@theconversation/shared-libraries/currentRegionFromMetaTag"
import renderPromos from "promos/renderPromos"

/**
 * @param {Object} promosContext
 */
export default async function renderContentPromos(promosContext) {
  const region = currentRegionFromMetaTag() || "no-region"

  const {
    collaborator_ids: collaboratorIds,
    section_ids: sectionIds,
    section_slugs: sectionSlugs,
    topic_ids: topicIds,
    content_language: contentLanguage,
    user,
  } = promosContext

  const context = {
    content: {
      collaboratorIds,
      language: contentLanguage,
      sectionIds,
      sectionSlugs,
      topicIds,
    },
    region,
    user,
  }

  return renderPromos(context)
}
